import React from 'react';
import {Box, Button, Card, CardContent, Grid, Stack, Typography} from "@mui/material";
import palette from "../../../../../theme/palette";
import Loading from "../../../../../components/loading";
import {When} from "react-if";

interface Props {
    handleNext:()=>void;
    handleBack:()=>void;
    isTeamsLoading : boolean;
}

export const About: React.FC<Props> = ({isTeamsLoading,handleNext,handleBack}) => {
    return (
        <Grid container>
            <Grid item md={5} margin={'auto'}>
                <Card>
                    <CardContent sx={{padding:3}}>
                        <Stack>
                            <When condition={isTeamsLoading}>
                                <Loading color={palette.darkBlue}/>
                            </When>
                            <When condition={!isTeamsLoading}>
                                <Typography fontWeight={500} fontSize={18} sx={{mb:2}}>
                                    About Visit Risk Review
                                </Typography>
                                <Box sx={{mb:2}}>
                                    <Typography fontWeight={400} fontSize={16} color={'text.secondary'}>
                                        Visit Risk Review helps you evaluate the safety of addresses recorded
                                        during a Check on Me, giving you deeper insights into the
                                        environments where your staff is providing care. On the following screens,
                                        you can select one or more teams to review and specify a
                                        date range for the report.
                                    </Typography>
                                </Box>
                                <Grid
                                    marginTop={20}
                                    flexDirection={'row-reverse'}
                                    container
                                    spacing={2}
                                    mt={3}
                                >
                                    <Button disabled={isTeamsLoading} sx={{color:palette.darkBlue}} onClick={handleNext}>
                                        Next
                                    </Button>
                                    <Button disabled={false} color="inherit" onClick={handleBack}>
                                        Cancel
                                    </Button>
                                </Grid>
                            </When>
                        </Stack>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    )
}